export const ERROR_EXCEPTIONS = ['Internal server error'];
